import heroImage from "../assets/sign-in-hero.png"

/** Cosmic illustration for the sign-in / registration screen (2x export from Figma). */
export function SignInHero() {
  return (
    <img
      src={heroImage}
      alt=""
      aria-hidden
      className="h-auto w-full max-w-[382px] select-none"
      draggable={false}
    />
  )
}
